import moment from "moment";

export const getTime = (value, format) => {
  return moment(value?.toDate()).format(format);
};

export const convertVnTime = (value) => {
  return moment(value).tz("Asia/Ho_Chi_Minh").format("YYYY-MM-DD HH:mm:ss");
};
